import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';

import { StyledPackagesCustomDataView } from './PackagesCustomDataView.styles';
import getPackageColumns from '../helpers/getPackageColumns';

const PackagesCustomDataView = (props) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const columns = useMemo(
    () =>
      getPackageColumns({
        T,
        searchExpression: props.filters.searchExpression,
      }),
    [T, props.filters.searchExpression],
  );

  return (
    <StyledPackagesCustomDataView
      columns={columns}
      loadingMoreText={T.translate('LOADING_MORE')}
      errorText={T.translate('ERROR_LOADING_MORE')}
      {...props}
    />
  );
};

PackagesCustomDataView.propTypes = {
  multiple: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  entities: PropTypes.array.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  disabledIds: PropTypes.arrayOf(PropTypes.string),
  filters: PropTypes.object,
  setSelection: PropTypes.func,
  onChange: PropTypes.func,
  onLoadMore: PropTypes.func,
  onTryAgain: PropTypes.func,
};

export default PackagesCustomDataView;
